// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmationAlert_modal__GThQR","modalErro":"ConfirmationAlert_modalErro__BcFr+","modalErroShort":"ConfirmationAlert_modalErroShort__SZy1x"};